import DataItemTextarea from './DataItemTextarea';

export * from './DataItemTextarea';

export default DataItemTextarea;
